import { useState, useEffect } from "react";
import PropTypes from "prop-types";
import styles from "./storeCard.module.scss";
import config from "../../../config/index";
import CTAButton from "../../atoms/CTAButton/CTAButton";
import * as Analytics from "../../../services/analyticsUtag";

const StoreCard = ({
  data,
  handleOnClick,
  selectedStoreCard,
  variant,
  onSizeChange,
  showFewerEnabled,
  checkStoresShownLength,
  itemClassName,
  isFromModal,
  geoLocationIsAllowed
}) => {
  const [outOfStock, setOutOfStock] = useState(false);
  const [noClickandCollect, setNoClickandCollect] = useState(false);
  const env = config.env;
  const imagePrefix = config.envConfigs[env].imagePrefix;
  let [size, setSize] = useState(3);
  const dataLength = data?.length;

  const onShowmoreClick = () => {
    if (dataLength > size + 3) {
      setSize(size = size + 3);
      onSizeChange(size);
      checkStoresShownLength && checkStoresShownLength(size);
    } else {
      let val = dataLength - size;
      setSize(size + val);
      onSizeChange(size + val);
    }

    const pageName = Analytics.getUtagData(["page_name"]).page_name;
    Analytics.link({
      link_type: "o",
      link_name: `${pageName}: show more stores`
    });
  }

  const onShowfewerClick = () => {
    setSize(3);
    onSizeChange(3);
  }

  const itemImage = <img
    className={styles["storeCard__tracker-icon"]}
    src={`${imagePrefix}/assets/images/tracker-red.png`}
  />;

  const renderItemName = (item) => (<div className={styles["storeCard__heading"]}>
    {item.name.toLowerCase()}
  </div>)

  const renderItemDistance = (item) => (!isFromModal && geoLocationIsAllowed ? (
    <>
      <div className={styles["storeCard__location"] }>
        {Math.round(item.distance) + " km from your current location"}
      </div>
    </>
  ) : (
    <>
      <div className={styles["storeCard-modal-distance"]}>
        {geoLocationIsAllowed ? Math.round(item.distance) + " km from your current location" : ''}
      </div>
    </>
  )
  );

  const renderDetailsCard = (item) => (
    <>
      <div className={styles["item-container"]}>
        {itemImage}
        {renderItemName(item)}
      </div>
      {renderItemDistance(item)}
    </>
  );

  const renderCheckoutCard = (item, index) => {
    return <>
      <div className={styles["storeCard__heading-container"]}>
        {itemImage}
        {renderItemName(item)}
        {item?.inStock == false && !isFromModal && (
          <div className={styles["storeCard__no-stock"]}>
            {"Out of stock"}
          </div>
        )}
        {noClickandCollect && (
          <div className={styles["storeCard__no-click-and-collect"]}>
            {"No Click & Collect"}
          </div>
        )}
      </div>
      {!isFromModal && variant !== "closestStore" && 
      <div className={styles["storeCard__content"]}>
        {item.addressLineOne}
      </div>}
      {renderItemDistance(item)}
      <div
        className={`${selectedStoreCard === index
            ? styles["storeCard__triangle"]
            : ["d-none"]
          }`}
      >
        <div className={styles["storeCard__click"]}>
          <img
            className={styles["storeCard__click-tick"]}
            src={`${imagePrefix}/assets/images/tick.svg`}
            alt="tick"
          />
        </div>
      </div>
    </>
  }

  return (
    <>
      {data?.map((item, index) => (
        <>
          {index < size && (
            <div
              className={`${styles["storeCard"]} ${item.inStock == false ? styles["greyOutCard"] : ""} ${selectedStoreCard === index
                  ? styles["storeCard-greenBorder"]
                  : [""]
                } ${itemClassName} ${isFromModal ? styles["storeCard-modal"] : ''}`}
              onClick={() => {
                handleOnClick(index, item);
              }}
            >
              {itemClassName ? renderDetailsCard(item) : renderCheckoutCard(item, index)}
            </div>
          )}
        </>
      ))}

      {variant === "searchedStore" && variant !== "closestStore" && (
        <div className="text-center">
          <CTAButton className={`styles["storeCard-button"] ${!isFromModal ? styles["show-more-btn"] : ""}`} variant="outline black"
            handleClick={(data?.length > size) ? onShowmoreClick : onShowfewerClick}
          >
            {(data?.length > size)
              ? <label>{"+ Show more stores"}</label>
              : <label>{"- Show fewer stores"}</label>}
          </CTAButton>
        </div>
      )}
    </>
  );
};

StoreCard.defaultProps = {
  isFromModal: false
}

StoreCard.propTypes = {
  data: PropTypes.array,
  handleOnClick: PropTypes.func,
  onSizeChange: PropTypes.func,
  variant: PropTypes.string,
  selectedStoreCard: PropTypes.number,
  showFewerEnabled: PropTypes.bool,
  isFromModal: PropTypes.bool,
  geoLocationIsAllowed: PropTypes.bool
};

StoreCard.defaultProps = {
  data: [],
};

export default StoreCard;
